import React from "react";
import { 
  Box, 
  Button, 
  Typography, 
  Container, 
  Paper
} from "@mui/material";
import AppleIcon from "@mui/icons-material/Apple";
import AndroidIcon from "@mui/icons-material/Android";
import { useTranslation } from "react-i18next";

const DownloadApp = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(to bottom, #e8f0fe, #d0e0fc)",
        py: 6,
        px: 2,
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={6}
          sx={{
            p: 4,
            borderRadius: 2,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography 
            variant="h4" 
            component="h1" 
            sx={{ 
              fontWeight: "bold", 
              mb: 1,
              textAlign: "center",
            }}
          >
            {t("downloadPage.downloadAppTitle")}
          </Typography>
          
          <Typography 
            variant="body1" 
            color="text.secondary" 
            sx={{ mb: 4, textAlign: "center" }}
          >
           {t("downloadPage.available")} 
          </Typography>

          <Button
            variant="contained"
            href="https://apps.apple.com/us/app/id1502213567"
            startIcon={<AppleIcon />}
            sx={{
              bgcolor: "#000000",
              color: "#ffffff",
              textTransform: "none",
              mb: 2,
              width: "100%",
              py: 1.5,
              borderRadius: 1.5,
              fontWeight: 500,
              "&:hover": {
                bgcolor: "#333333",
              },
            }}
          >
            {t("downloadPage.downloadOnAppStore")}
          </Button>

          <Button
            variant="contained"
            href="https://play.google.com/store/apps/details?id=com.miwotec.xline"
            startIcon={<AndroidIcon />}
            sx={{
              bgcolor: "#4CAF50",
              color: "#ffffff",
              textTransform: "none",
              width: "100%",
              py: 1.5,
              borderRadius: 1.5,
              fontWeight: 500,
              "&:hover": {
                bgcolor: "#43A047",
              },
            }}
          >
            {t("downloadPage.getItOnGooglePlay")}
          </Button>
        </Paper>
      </Container>
      
    </Box>
  );
};

export default DownloadApp;